import React, { useState } from "react";
import { Tabs } from "flowbite-react";
import { HiSearch } from "react-icons/hi";
import LocalizaPessoaPage from "./LocalizaPessoaPage";
import LocalizaEmpresaPage from "./LocalizaEmpresaPage";

const LocalizaPage = () => {
  const [tab, setTab] = useState("pessoa");

  return (
    <div className="p-4">
      <div className="flex border-b mb-4">
        <button
          onClick={() => setTab("pessoa")}
          className={`px-6 py-3 font-medium text-sm border-b-2 ${
            tab === "pessoa"
              ? "border-blue-800 text-blue-800"
              : "border-transparent text-gray-600 hover:text-blue-500"
          }`}
        >
          Pessoa
        </button>
        <button
          onClick={() => setTab("empresa")}
          className={`ml-4 px-6 py-3 font-medium text-sm border-b-2 ${
            tab === "empresa"
              ? "border-blue-800 text-blue-800"
              : "border-transparent text-gray-600 hover:text-blue-500"
          }`}
        >
          Empresa
        </button>
      </div>

      {tab === "pessoa" && <LocalizaPessoaPage />}
      {tab === "empresa" && <LocalizaEmpresaPage />}
    </div>
  );
};

export default LocalizaPage;
